import { t } from "i18next";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import AppointmentListItem from "./appointmentListItem";
import WaitListItem from "./waitListItem";

function UpcomingAppointmentView({ setId, setIsReschedule, setAttendDetail }) {
  let history = useHistory();
  let cancelURL = "";
  const [upcomingAppt, setUpcomingAppt] = useState([]);
  const [selectedAppt, setSelectedAppt] = useState([]);
  const [patientWaitList, setPatientWaitList] = useState({});
  const [fetchingData, setFetchingData] = useState(true);
  const [hasAppointments, setHasAppointments] = useState(false);
  const [hasWaitlist, setHasWaitist] = useState(false);

  const fetchUpcomingAppointments = () => {
    const attendeeId = JSON.parse(localStorage.getItem("pid"));
    const URL = `/api/v1/appointments/upcoming?attendeeId=${attendeeId}`;
    const token = "Bearer " + localStorage.getItem("token");
    return fetch(URL, {
      method: "GET",
      headers: {
        Accept: "application/json; charset=utf-8",
        "Content-Type": "application/json",
        Authorization: token.replace(/['"]+/g, ""),
      },
      credentials: "include",
    }).then((response) => response.json());
  };

  const processUpcomingAppointments = (response) => {
    const _state =
      response["status"]["success"] && response.appointments !== null;
    setHasAppointments(_state);
    if (_state) {
      console.log(response.appointment);
      setUpcomingAppt(response.appointments);
    }
  };

  const processUpcomingWaitlist = (response) => {
    const _state = response["status"]["success"] && response.wait !== null;
    setHasWaitist(_state);
    if (_state) {
      console.log(response.wait);
      setPatientWaitList(response.wait);
    }
  };

  const fetchUpcomingWaitingList = () => {
    const attendeeId = JSON.parse(localStorage.getItem("pid"));
    const URL = `/api/v1/waiting?patientId=${attendeeId}`;
    const token = "Bearer " + localStorage.getItem("token");
    return fetch(URL, {
      method: "GET",
      headers: {
        Accept: "application/json; charset=utf-8",
        Authorization: token.replace(/['"]+/g, ""),
      },
      credentials: "include",
    }).then((response) => response.json());
  };

  const fetchAllData = () => {
    setFetchingData(true);
    Promise.all([fetchUpcomingAppointments(), fetchUpcomingWaitingList()]).then(
      (values) => {
        setFetchingData(false);
        const appointmentResponse = values[0];
        const waitlistResponse = values[1];
        processUpcomingAppointments(appointmentResponse);
        processUpcomingWaitlist(waitlistResponse);
      }
    );
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const rescheduleHandler = (selectedAppt) => {
    setIsReschedule(true);
    // setId(selectedAppt.id);
    history.push(
      `/schedule-appointment?reschedule=true&id=${selectedAppt.id}&online=${
        selectedAppt.online
      }&isDietitian=${selectedAppt?.ownerMetadata?.code.slice(0, 2) == "DT"}`
    );
  };

  //fetch cancel API
  const cancelSlot = async () => {
    cancelURL = `/api/v1/appointments/${
      selectedAppt?.id ? selectedAppt.id : "NaN"
    }/cancel`;
    const token = "Bearer " + localStorage.getItem("token");
    try {
      const response = await fetch(cancelURL, {
        method: "PUT",
        headers: {
          Accept: "application/json; charset=utf-8",
          "Content-Type": "application/json",
          Authorization: token.replace(/['"]+/g, ""),
        },
        credentials: "include",
      });
      const data = await response.json();
      setUpcomingAppt([]);
      setSelectedAppt();
      if (response.status !== 200) {
        return;
      } else {
        fetchAllData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const selectedUpcomingList = moment(new Date(upcomingAppt?.date)).format(
    "DD MMMM, dddd, YYYY"
  );
  const selectedWaitList = moment(new Date(patientWaitList?.date)).format(
    "DD MMMM, dddd, YYYY"
  );

  const subView = () => {
    if (fetchingData) {
      return (
        <div
          style={{
            margin: "auto",
            display: "flex",
            justifyContent: "center",
          }}
          id="loader"
        ></div>
      );
    } else if (!hasAppointments && !hasWaitlist) {
      return (
        <div className="text-center fs-4">
          {t("appointment.UPCOMING-APPOINTMENT.description2")}
        </div>
      );
    } else if (hasAppointments) {
      console.log("upcoming", upcomingAppt);

      return upcomingAppt?.map((appointment) => (
        <AppointmentListItem
          key={appointment.id}
          setId={setId}
          upcomingAppt={appointment}
          onReschedule={rescheduleHandler}
          setSelectedAppt={setSelectedAppt}
          setAttendDetail={setAttendDetail}
        />
      ));
    } else if (hasWaitlist) {
      return <WaitListItem patientWaitList={patientWaitList} />;
    } else {
      <></>;
    }
  };

  return (
    <>
      {subView()}
      <div
        style={{ bottom: upcomingAppt?.length > 0 ? 0 : "calc(50% - 120px)" }}
        className="btn_block bottom_button d-flex align-items-center justify-content-center"
      >
        <button
          id="btn_bookapp"
          className="btn btn_primary"
          // disabled={showUpcomingList}
          disabled={upcomingAppt?.length > 1 || fetchingData}
          onClick={() => history.push("/schedule-appointment")}
        >
          {t("appointment.UPCOMING-APPOINTMENT.button1")}
        </button>
      </div>
      {/* Unwanted code?
        <div className="custom_tp_app tab-pane fade" id="past">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="box_view_app">
                <div className="head_view d-flex justify-content-between align-items-center">
                  <span className="txt_normal">{doctorName}</span>
                  <span className="txt_small">{t('appointment.DOCTOR.doctor1')}</span>
                </div>
                <span className="txt_normal">{upcomingAppt?.startTime}</span>
                <span className="txt_normal">{upcomingAppt?.date}</span>
                <span className="txt_normal">{clinic}</span>
                <Link to="#" className="link_status ">
                  {t('appointment.BUTTON.completed')}
                </Link>
              </div>
            </div>
          </div>
        </div>
        */}
      {/* <!-- START MODAL FOR APPOINTMENT CANCEL --> */}
      <div className="custom_modal modal fade text-center" id="modal_appcancel">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center mb-4">
                  {t("appointment.CANCEL.cancel")}
                </h3>
                <div className="btn_block d-flex align-items-center justify-content-center mb-2">
                  <button
                    className="btn btn_outline p-2"
                    data-bs-dismiss="modal"
                  >
                    {t("appointment.CANCEL.no")}
                  </button>
                  <button
                    id="btn_cancelled_app"
                    className="btn btn_primary p-2"
                    data-bs-dismiss="modal"
                    onClick={() => cancelSlot()}
                  >
                    {t("appointment.CANCEL.yes")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpcomingAppointmentView;
